'use strict';

import React, { PureComponent } from 'react';
import { View } from 'react-native';
import { LoadingView } from 'base/tmpl/common/LoadingView';
import SafeAreaContainer from 'tmpl/common/SafeAreaContainer';
import Toast from 'utils/Toast';
import CommonBridge from 'common/CommonBridge';
import StdNavBar from 'tmpl/common/StdNavBar';
import NoResult from 'tmpl/common/NoResult';
import {
  mergeAndUploadContent,
  setJSExceptionHandler,
  errorMessageRun,
  setJSExceptionHandlerWeb,
} from 'common/ErrorUtils';
// import { GuideBar } from 'base/tmpl/common/GuideBar';
import { performanceStat } from './performanceStat';
import { PerformanceCompt } from './PerformanceCompt';

// import { Uri } from './Uri';

const safeareaStyle = {
  flex: 1,
  flexDirection: 'column',
  backgroundColor: '#fff',
  overflow: 'hidden',
};

/**
 *   导航栏页基类
 */
export default class BaseNavigationView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      title: this.props.title,
      dataLoadState: 0, // 0正在加载，默认值！
    };
    this.overlayTouchBar = false;
    this.navigatorName = props.navigatorName;
    this.showNavBarBottomSeparator = true;
    this.showBackBar = !(CommonBridge.isWeb() && window.ua && window.ua.pc); // PC跳转到M站的售后页面不显示左侧返回箭头
    this.backIng = false;
    this.openUrl = this.openUrl.bind(this);
    this.finishAndOpenUrl = this.finishAndOpenUrl.bind(this);
    this.onBackPress = this.onBackPress.bind(this);
    this.onBackPressN = this.onBackPressN.bind(this);
    if (this.navigatorName !== '$$') {
      performanceStat.freePage();
      performanceStat.initPage(this.navigatorName, this.props.uri);
      this.pageInTime = Date.now();
    }
    CommonBridge.isWeb()
      ? setJSExceptionHandlerWeb()
      : setJSExceptionHandler((e, hasError) => {
          const errorType = hasError ? 'jsError' : e && e.type;
          errorMessageRun(e, errorType, (errorString) => {
            mergeAndUploadContent({
              message: errorString,
              pageUrl: this.props.uri || this.navigatorName,
              type: errorType,
            });
          });
        }, true);
    if (CommonBridge.isWeb()) {
      window.addEventListener('pageshow', this.pageshow);
      window.addEventListener('pagehide', this.pagehide);
    }
  }

  pageshow() {
    if (this.pageIsHide) {
      window.location.reload();
    }
  }

  pagehide() {
    this.pageIsHide = true;
  }

  componentWillUnmount() {
    if (CommonBridge.isWeb()) {
      window.removeEventListener('pageshow', this.pageshow);
      window.removeEventListener('pagehide', this.pagehide);
    }
  }

  showMessage(msg, tagWrap = false) {
    if (tagWrap) {
      Toast.showWrapedMsg(msg);
    } else {
      Toast.show(msg);
    }
  }

  openUrl(...args) {
    this.props.openUrl(...args);
  }

  /**
   * 获取页面的scm + spm 用于openUrl的url拼接 & spmref=spmref scmv2_num = scmv2_num last_scmv2 = last_scmv2
   * @param {*} param
   */
  getSpmAndScm = (param) => {
    // {
    //   url: 'http://m.xiaomiyoupin.com/mfbs/mstd/detail',
    //   scmv2: 'test',
    //   b: '$detail$',
    //   c: 'area',
    // }
    return this.props.YPStatSend && this.props.YPStatSend.getSpmAndScm(param);
  };

  getSpm = (param) => {
    this.props.YPStatSend && this.props.YPStatSend.getSpmAndScm(param);
  };

  onBackPress() {
    this.props.onBackPress();
  }

  showConfirm(params) {
    Toast.confirm(params);
  }

  showOKConfirm(params) {
    Toast.singleConfirm(params);
  }

  renderLoadingView() {
    return <LoadingView style={{ flex: 1 }} />;
  }

  // 请求全局资源位函数，调用bsl模块
  requestGlobalData = (pageType, params = {}) => {
    !CommonBridge.isWeb() && this.props.showGlobalResource(pageType, params);
  };

  renderContent() {
    return null;
  }

  renderLoadedErrorView() {
    return (
      <NoResult
        imgSrc={{ uri: 'https://img.youpin.mi-img.com/shopcenter/144194d04c46a84e0cd81374528940ad.png' }}
        type="default"
        tipTxt={`数据加载异常，请稍后再试~(code: -1)`}
        btnTxt="返   回"
        btnClickFun={this.onBackPress}
      />
    );
  }

  renderNoLoginView() {
    return null;
  }

  renderCustomView() {
    return null;
  }

  onBackPressN(n) {
    this.props.onBackPressN(n);
  }

  finishAndOpenUrl(url, animate) {
    this.props.finishAndOpenUrl(url, animate);
  }

  showNavBar() {
    return true;
  }

  _renderEmptyLeftBar() {
    return null;
  }

  renderRightButton() {
    return null;
  }

  renderBackgroundImage() {
    return null;
  }

  renderTitle() {
    return null;
  }

  onPageIn() {}

  onPageBack() {}

  /**
   * 渲染标准导航栏，如果是自定义导航栏，请重写此方法
   * @returns {XML}
   */
  renderNavigationBar() {
    if (!this.showNavBar()) {
      return null;
    }

    let _style = {
      zIndex: 999,
    };
    if (CommonBridge.isWeb()) {
      this.refreshTime = new Date().getTime();
      _style = {};
    }
    if (this.navBarBackground) {
      _style.backgroundColor = this.navBarBackground;
    } else {
      _style.backgroundColor = '#ffffff';
    }
    if (this.navBarStyle) {
      _style = Object.assign({}, _style, this.navBarStyle);
    }
    return (
      <StdNavBar
        style={_style}
        title={this.state.title}
        showBottomSeparator={this.showNavBarBottomSeparator}
        renderLeftButton={this.showBackBar ? this.renderLeftButton || null : this._renderEmptyLeftBar}
        renderRightButton={this.renderRightButton}
        refreshTime={this.refreshTime}
        onBackPress={this.onBackPress}
        titleWidth={this.state.titleWidth}
        renderBackgroundImage={this.renderBackgroundImage}
        renderTitle={this.renderTitle}
      />
    );
  }

  render() {
    const loadState = this.dataLoadState || this.state.dataLoadState;
    let contentView = null;
    switch (loadState) {
      case 0:
      case undefined:
        contentView = this.renderLoadingView();
        break;
      case 1:
        contentView = this.renderContent();
        break;
      case -1:
        contentView = this.renderLoadedErrorView();
        break;
      case -2:
        contentView = this.renderNoLoginView();
        break;
      case 2:
        contentView = this.renderCustomView();
        break;
      default:
        break;
    }
    return (
      <View style={{ flex: 1 }}>
        {/* <GuideBar /> */}
        <SafeAreaContainer
          overlayTouchBar={this.props.isModalShow ? true : this.overlayTouchBar}
          style={this.props.isModalShow ? { ...safeareaStyle, backgroundColor: 'transparent' } : safeareaStyle}
        >
          {this.renderNavigationBar()}
          {contentView}
          <PerformanceCompt pageInTime={this.pageInTime} dataLoadState={loadState} />
        </SafeAreaContainer>
      </View>
    );
  }
}
